import fetchApi, { FetchRequestConfig } from "../../lib/fetchApi";

export const apiService = {
    post: async <TRequest, TResponse>(
        url: string,
        body: TRequest,
        config?: FetchRequestConfig<TRequest>
    ): Promise<TResponse> => {
        const response = await fetchApi.post<TResponse>(
            url,
            body,
            config
        ) as TResponse;

        return response;
    },

    put: async <TRequest, TResponse>(
        url: string,
        body: TRequest,
        params?: any
    ): Promise<TResponse> => {
        const response = await fetchApi.put<TResponse>(
            url,
            body,
            { params }
        ) as TResponse;

        return response;
    },

    get: async <TResponse>(
        url: string,
        config?: FetchRequestConfig
    ): Promise<TResponse> => {
        const response = await fetchApi.get<TResponse>(
            url,
            config
        ) as TResponse;

        return response;
    },
};